import React, { useState, useRef } from 'react'; 
import './Schools.css';

const schoolsList = [
  { id: 1, name: "Cavite State University - Main Campus", alias: "CvSU - Main", logo: "pics/LogoSchools/CAVSU-MAIN.png" },
  { id: 2, name: "Colegio de Muntinlupa", alias: "CdM", logo: "pics/LogoSchools/CDM.png" },
  { id: 3, name: "De La Salle University – Dasmariñas", alias: "DLSU-D", logo: "pics/LogoSchools/DLSU-D.png" },
  { id: 4, name: "De La Salle University – Manila", alias: "DLSU-M", logo: "pics/LogoSchools/DLSU.png" },
  { id: 5, name: "Far Eastern University - Alabang", alias: "FEU Alabang", logo: "pics/LogoSchools/FEU-A.png" },
  { id: 6, name: "Far Eastern University - Institute of Technology", alias: "FEU-TECH", logo: "pics/LogoSchools/FEU-TECH.png" },
  { id: 7, name: "Mapua University - Manila", alias: "MU-M", logo: "pics/LogoSchools/MU.png" },  
  { id: 8, name: "National University - Manila", alias: "NU-M", logo: "pics/LogoSchools/NU-M.png" }, 
  { id: 9, name: "Pamantasan ng Lungsod ng Pasig", alias: "PLP", logo: "pics/LogoSchools/PLP.png" }, 
  { id: 10, name: "Polytechnic University of the Philippines - Maragondon Campus", alias: "PUP-MC", logo: "pics/LogoSchools/PUP-C.png" },
  { id: 11, name: "Polytechnic University of the Philippines - Santa Rosa Campus", alias: "PUP-SRC", logo: "pics/LogoSchools/PUP-SR.png" },
  { id: 12, name: "Polytechnic University of the Philippines - Sto. Tomas Campus", alias: "PUP-STC", logo: "pics/LogoSchools/PUP-B.png" }, 
  { id: 13, name: "Polytechnic University of the Philippines - Manila", alias: "PUP-Manila", logo: "pics/LogoSchools/PUP.png" }, 
  { id: 14, name: "Rizal Technological University - Mandaluyong", alias: "RTU - M", logo: "pics/LogoSchools/RTU.png" },  
  { id: 15, name: "Technological Institue of the Philippines - Manila", alias: "TIP - M", logo: "pics/LogoSchools/TIP.png" },
  { id: 16, name: "Technological Institue of the Philippines - Quezon City", alias: "TIP - QC", logo: "pics/LogoSchools/TIP.png" },  
  { id: 17, name: "University of Batangas", alias: "UB", logo: "pics/LogoSchools/UB.png" },
  { id: 19, name: "University of Santo Tomas - Manila", alias: "UST - M", logo: "pics/LogoSchools/UST.png" },
];

const legacySchools = [
  { id: 201, name: "Adamson University", logo: "pics/LogoSchools/ADU.png" },
  { id: 202, name: "Asia Pacific College", logo: "pics/LogoSchools/APC.png" },
  { id: 203, name: "Ateneo de Manila University", logo: "pics/LogoSchools/ADMU.png" }, 
  { id: 204, name: "Batangas State University", logo: "pics/LogoSchools/BSU.png" },
  { id: 205, name: "Bulacan State University", logo: "pics/LogoSchools/BULSU.png" },
  { id: 206, name: "Caraga State University", logo: "pics/LogoSchools/CARAGA SU.png" },
  { id: 207, name: "Cavite State University", logo: "pics/LogoSchools/CAVSU-MAIN.png" },
  { id: 208, name: "Cebu Institute of Technology - University", logo: "pics/LogoSchools/CITU.png" },
  { id: 209, name: "Colegio De Muntinlupa", logo: "pics/LogoSchools/CDM.png" },
  { id: 210, name: "Colegio de San Gabriel Arcangel, Inc.", logo: "pics/LogoSchools/CDGSA.png" },
  { id: 211, name: "Colegio de San Juan de Letran - Calamba", logo: "pics/LogoSchools/CDSJDL.png" },
  { id: 212, name: "De La Salle University - Dasmariñas", logo: "pics/LogoSchools/DLSU-D.png" },
  { id: 213, name: "De La Salle University - Manila", logo: "pics/LogoSchools/DLSU.png" },
  { id: 214, name: "Eulogio “Amang” Rodriguez IST", logo: "pics/LogoSchools/EARIST.png" },
  { id: 215, name: "Far Eastern University - Alabang", logo: "pics/LogoSchools/FEU-A.png" },
  { id: 216, name: "Far Eastern University Institute of Technology", logo: "pics/LogoSchools/FEU-TECH.png" },
  { id: 217, name: "FEATI University", logo: "pics/LogoSchools/FEATIU.png" },
  { id: 218, name: "ICCT Colleges", logo: "pics/LogoSchools/ICCT.png" },
  { id: 219, name: "Jose Rizal Univeristy", logo: "pics/LogoSchools/JRU.png" },
  { id: 220, name: "Laguna State Polytechnic University", logo: "pics/LogoSchools/LSPU.png" },
  { id: 221, name: "Lyceum of the Philippines University - Cavite", logo: "pics/LogoSchools/LPU.png" },
  { id: 222, name: "Mapua University - Manila", logo: "pics/LogoSchools/MU.png" },
  { id: 223, name: "National University - Manila", logo: "pics/LogoSchools/NU-M.png" },
  { id: 224, name: "New Era University", logo: "pics/LogoSchools/NEU.png" },
  { id: 225, name: "Pamantasan ng Cabuyao", logo: "pics/LogoSchools/PNC.png" },
  { id: 226, name: "Pamantasan ng Lungsod ng Maynila", logo: "pics/LogoSchools/PLM.png" },
  { id: 227, name: "Pamantasan ng Lungsod ng Pasig", logo: "pics/LogoSchools/PLP.png" },
  { id: 228, name: "PUP - Santo Tomas", logo: "pics/LogoSchools/PUP-B.png" },
  { id: 229, name: "PUP - Sta. Mesa", logo: "pics/LogoSchools/PUP-M.png" },
  { id: 230, name: "PUP - Sta. Rosa", logo: "pics/LogoSchools/PUP-SR.png" },
  { id: 231, name: "PUP - Taguig", logo: "pics/LogoSchools/PUP-T.png" },
  { id: 232, name: "Quezon City Polytechnic University", logo: "pics/LogoSchools/QCU.png" },
  { id: 233, name: "Rizal Technological University", logo: "pics/LogoSchools/RTU.png" },
  { id: 234, name: "TIP - Manila", logo: "pics/LogoSchools/TIP.png" },
  { id: 235, name: "TIP - Quezon City", logo: "pics/LogoSchools/TIP.png" },
  { id: 236, name: "TUP - Taguig", logo: "pics/tup.png" },
  { id: 237, name: "TUP - Visayas", logo: "pics/tup.png" },
  { id: 238, name: "University of Batangas", logo: "pics/LogoSchools/UB.png" },
  { id: 239, name: "University of San Carlos", logo: "pics/LogoSchools/USC.png" },
  { id: 240, name: "University of Santo Tomas", logo: "pics/LogoSchools/UST.png" },
  { id: 241, name: "University of the East - Caloocan", logo: "pics/LogoSchools/UE.png" },
  { id: 242, name: "University of the East - Manila", logo: "pics/LogoSchools/UE.png" },
  { id: 243, name: "UP - Diliman", logo: "pics/LogoSchools/UP.png" },
  { id: 244, name: "UPHSD - Las Piñas", logo: "pics/LogoSchools/UPHSD.png" },
  { id: 245, name: "UPHSD - Molino", logo: "pics/LogoSchools/UPHSD.png" },
  { id: 246, name: "URS - Morong", logo: "pics/LogoSchools/URS.png" },
  { id: 247, name: "Wesleyan University - Philippines", logo: "pics/LogoSchools/WUP.png" },
];

const Schools = () => {
  const [view, setView] = useState('2026'); // '2026' or 'legacy'
  const [searchTerm, setSearchTerm] = useState("");
  const scrollRef = useRef(null);
  const [scrollProgress, setScrollProgress] = useState(0);

  const activeList = view === '2026' ? schoolsList : legacySchools;

  const filteredSchools = activeList.filter((school) => {
    const search = searchTerm.toLowerCase();
    const nameMatches = school.name.toLowerCase().includes(search);
    const aliasMatches = school.alias?.toLowerCase().includes(search);
    
    return nameMatches || aliasMatches;
});

  const handleScroll = () => {
    if (scrollRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
      const progress = (scrollLeft / (scrollWidth - clientWidth)) * 100;
      setScrollProgress(progress || 0);
    }
  };

  const scroll = (direction) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: direction === 'left' ? -600 : 600, behavior: 'smooth' });
    }
  };

  return (
    <div className="schools-page">
      <section className="schools-header-section">
        <h1 className="title">
          <span className="green">{view === '2026' ? 'PARTICIPATING' : 'THROUGHOUT'}</span>
          <span className="white"> {view === '2026' ? 'SCHOOLS' : 'THE YEARS'}</span>
        </h1>
        <div className="mech-divider"></div>

        {/* --- VIEW TOGGLE --- */}
        <div className="view-toggle-container">
          <button 
            className={`toggle-btn ${view === '2026' ? 'active' : ''}`} 
            onClick={() => {setView('2026'); setScrollProgress(0);}}
          >
            PARTICIPANTS 2026
          </button>
          <button 
            className={`toggle-btn ${view === 'legacy' ? 'active' : ''}`} 
            onClick={() => {setView('legacy'); setScrollProgress(0);}}
          >
            THROUGHOUT THE YEARS
          </button>
        </div>
        
        <div className="search-container">
          <input
            type="text"
            placeholder={`Search ${view === '2026' ? 'Participants' : 'Schools Throughout the Years'}...`}
            className="school-search-input"
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </section>

      <div className="matrix-navigation-container">
        <button className="nav-arrow left" onClick={() => scroll('left')}>&#10094;</button>

        <div className="matrix-scroll-wrapper" ref={scrollRef} onScroll={handleScroll}>
          <div className={`matrix-grid ${view === 'legacy' ? 'legacy-mode' : ''}`}>
            {filteredSchools.map((school) => (
              <div key={school.id} className="school-card-matrix">
                <div className="school-logo-frame">
                  <img src={school.logo || "pics/bnt.png"} alt={school.name} loading="lazy" />
                </div>
                <div className="school-info"><p>{school.name}</p></div>
              </div>
            ))}
          </div>
        </div>

        <button className="nav-arrow right" onClick={() => scroll('right')}>&#10095;</button>
      </div>

      <div className="scroll-indicator-container">
        <div className="progress-bar-bg">
          <div className="progress-bar-fill" style={{ width: `${scrollProgress}%` }}></div>
        </div>
        <p className="scroll-hint">
          {view === '2026' ? 'Schools That Are Pariticpating' : 'Schools That Participate Throughout The Years'}
        </p>
      </div>
    </div>
  );
};

export default Schools;